/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Gabriel Ibenye",
  title: "Hi all, I'm Gabriel",
  subTitle: emoji(
    "DevOps & Site Reliability & Cloud Engineer 🚀 | Azure & MS 365 Certified | Terraform Specialist | Automating cloud infrastructure, securing deployments, and driving operational excellence."
  ),
  resumeLink: "https://drive.google.com/uc?export=download&id=1BltYX71afb9kSPdOVJNobV7sfTNId3Et",
  displayGreeting: true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/gabbyti",
  linkedin: "https://www.linkedin.com/in/gabbyti/",
  gmail: "hello@gabrielibenye.com",
  gitlab: "https://gitlab.com/gabbyti",
  medium: "https://medium.com/@gabbyti",
  stackoverflow: "https://stackoverflow.com/users/10191288/gabe",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I Do",
  subTitle: "BUILDING SCALABLE CLOUD INFRASTRUCTURE & AUTOMATING EVERYTHING",
  skills: [
    emoji("⚡ Architect and deploy cloud-native solutions on AWS and Azure"),
    emoji("⚡ Create automated CI/CD pipelines with GitHub Actions, GitLab, and Azure DevOps"),
    emoji("⚡ Build resilient Kubernetes clusters and helm-managed deployments"),
    emoji("⚡ Implement monitoring, alerting, and logging for robust observability"),
    emoji("⚡ Craft resusable terraform modules for consistent infrastructure deployments"),
    emoji("⚡ Optimize cloud costs through resource management and performance tuning")
  ],
  softwareSkills: [
    { skillName: "Terraform", fontAwesomeClassname: "fas fa-code" },
    { skillName: "Kubernetes", fontAwesomeClassname: "fas fa-network-wired" },
    { skillName: "AWS", fontAwesomeClassname: "fab fa-aws" },
    { skillName: "Azure", fontAwesomeClassname: "fab fa-microsoft" },
    { skillName: "Docker", fontAwesomeClassname: "fab fa-docker" },
    { skillName: "Python", fontAwesomeClassname: "fab fa-python" },
    { skillName: "Node.js", fontAwesomeClassname: "fab fa-node" },
    { skillName: "GitHub", fontAwesomeClassname: "fab fa-github" },
    { skillName: "CI/CD", fontAwesomeClassname: "fas fa-infinity" }
  ],
  display: true
};

// Education Section

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "George Brown College, Toronto, ON",
      logo: require("./assets/images/gbc.png"),
      subHeader: "Postgraduate Certificate in Cloud Computing Technologies",
      duration: "January 2025 – December 2025",
      desc: `This program emphasizes real-world, enterprise-grade cloud infrastructure. I've built and managed simulated environments using Microsoft 365, SharePoint, OneDrive, and Defender for Office 365. In hands-on Windows Server labs, I configured and deployed Active Directory, DHCP, DNS, and set up Hyper-V replication. I also completed Microsoft Azure labs covering ARM Templates, Load Balancers, Entra ID Connect, and Azure cost management. Additionally, I designed and deployed networks using Cisco Packet Tracer to simulate VLANs, subnetting, and DNS configurations.`
    },
    {
      schoolName: "Madonna University",
      logo: require("./assets/images/madonna.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2015 – August 2019",
      desc: `This program laid the foundation of my software engineering skills, with a focus on system analysis, databases, and programming. For my final-year project, I developed a cloud-hosted Blood Bank Management System using PHP and Laravel. The application included donor registration, inventory tracking, and hospital request processing. It demonstrated my ability to build full-stack, database-driven applications with real-world healthcare relevance.`
    }
  ]
};



// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true,
  experience: [
    { Stack: "Cloud & DevOps", progressPercentage: "90%" },
    { Stack: "Automation & Scripting", progressPercentage: "85%" },
    { Stack: "Infrastructure as Code", progressPercentage: "90%" }
  ],
  displayCodersrank: false
};


// Work experience section

const workExperiences = {
  display: true,
  experience: [
    {
      role: "DevOps Cloud Engineer",
      company: "Vibes Meet LLC",
      companylogo: require("./assets/images/vibvibesmeetLog.jpeg"),
      date: "Mar 2025 – Present",
      desc: "Successfully implemented an unattended immutable infrastructure CI/CD pipeline for the Python backend API using GitHub Actions, HashiCorp Packer, Terraform, and AWS. Introduced Terraform for infrastructure-as-code, improving deployment speed, consistency, and team collaboration. Achieved a 40% reduction in AWS cloud costs through resource optimization, instance right-sizing, and storage improvements. Authored comprehensive documentation covering setup, workflows, and best practices to support long-term team adoption and maintenance."
    },
    {
      role: "Cloud DevOps Engineer | SRE | Sysadmin",
      company: "Qore Technologies",
      companylogo: require("./assets/images/qore.jpeg"),
      date: "Oct 2019 – May 2024",
      desc: "Led the rollout of a scalable Azure Kubernetes Service (AKS) cluster, implemented GitOps CI/CD pipelines using Azure DevOps, ACR, ArgoCD, Helm, and Bitbucket. Set up full monitoring with Prometheus and Grafana, achieving 100% cluster and application observability. Developed and enhanced application features in C#, and improved deployment cycles by 30% using Azure DevOps and Jenkins."
    },

  ]
};


/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Transcript🏆 "),
  subtitle:
    "Professional Certifications and Achievements in Cloud Technologies",

  achievementsCards: [
    {
      title: "George Brown College Transcript",
      subtitle: "Postgraduate Certificate in Cloud Computing Technologies",
      image: require("./assets/images/gbc.png"),
      imageAlt: "George Brown College Transcript",
      footerLink: [
        {
          name: "View Transcript",
          url: "https://1drv.ms/b/c/9cb150fe1ac9adbf/EQg7i-fUC6BJnfoLw-w3nGsBvEgjD8BHu4fAt5IIQcmmBQ?e=P00xew"
        }
      ]
    },
    {
      title: "Microsoft Certified: Azure Administrator Associate",
      subtitle:
        "Validated expertise in implementing, managing, and monitoring Azure infrastructure, including virtual networking, storage, compute, identity, security, and governance.",
      image: "https://learn.microsoft.com/media/learn/certification/badges/microsoft-certified-associate-badge.svg?branch=main",
      imageAlt: "Azure Administrator Associate Logo",
      footerLink: [
        {
          name: "View Certification",
          url: "https://learn.microsoft.com/api/credentials/share/en-us/gabbyti/F25CEB5FD5C4A727"
        }
      ]
    },
    {
      title: "Google Cloud Digital Leader",
      subtitle:
        "Demonstrated understanding of cloud technology and Google Cloud's core products, services, and solutions.",
      image: require("./assets/images/google-cloud-digital-leader-badge.png"),
      imageAlt: "Google Cloud Digital Leader Logo",
      footerLink: [
        {
          name: "View Certification",
          url: "https://www.credly.com/badges/9fab641d-7ed3-4b29-9b59-eead6f6f0670/public_url"
        }
      ]
    },
    {
      title: "Microsoft Certified: Azure Fundamentals",
      subtitle:
        "Verified knowledge of cloud concepts, Azure services, Azure workloads, security and privacy in Azure, and Azure pricing and support.",
      image: "https://learn.microsoft.com/media/learn/certification/badges/microsoft-certified-fundamentals-badge.svg?branch=main",
      imageAlt: "Azure Fundamentals Logo",
      footerLink: [
        {
          name: "View Certification",
          url: "https://learn.microsoft.com/api/credentials/share/en-us/gabbyti/8B7B34A9E391536B"
        }
      ]
    },
    {
      title: "Microsoft 365 Certified: Fundamentals",
      subtitle:
        "Demonstrated understanding of Microsoft 365 offerings, cloud services, security, compliance, privacy, and pricing.",
      image: "https://learn.microsoft.com/media/learn/certification/badges/microsoft-certified-fundamentals-badge.svg?branch=main",
      imageAlt: "Microsoft 365 Fundamentals Logo",
      footerLink: [
        {
          name: "View Certification",
          url: "https://learn.microsoft.com/api/credentials/share/en-us/gabbyti/4215FE5E3C5BD39A"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "Sharing insights and experiences about cloud architecture, DevOps practices, and infrastructure automation.",
  displayMediumBlogs: true,
  blogs: [
    
    {
      url: "https://dev.to/gabbyti/quick-setup-jenkins-on-aws-with-terraform-bash-1mj8",
      title: "Quick Setup: Jenkins on AWS with Terraform & Bash",
      description:
        "Learn how to automate Jenkins deployment on AWS using Infrastructure as Code with Terraform and Bash scripting."
    },
    {
      url: "https://dev.to/gabbyti/how-to-setup-jenkins-locally-with-oracle-virtualbox-vm-3cmi",
      title: "How to Setup Jenkins Locally with Oracle VirtualBox VM",
      description:
        "A step-by-step guide to setting up a Jenkins development environment using Oracle VirtualBox for local testing and learning."
    },
    {
      url: "https://dev.to/gabbyti/cloud-safety-how-to-establish-azure-point-to-site-vpn-connections-3e",
      title: "Cloud Safety: How to Establish Azure Point-to-Site VPN Connections",
      description:
        "Comprehensive guide on implementing secure Point-to-Site VPN connections in Azure for remote access to cloud resources."
    },
    {
      url: "https://dev.to/gabbyti/cloud-resume-challenge-azure-edition-part-2-1ke",
      title: "Cloud Resume Challenge: Azure Edition (Part 2)",
      description:
        "Comprehensive guide to implementing CI/CD pipelines using GitHub Actions and Azure DevOps. Covers infrastructure automation with Terraform, frontend deployments with Azure Storage/CDN, and backend deployments with Azure Functions."
    },
    {
      url: "https://dev.to/gabbyti/cloud-resume-challenge-azure-edition-part-1-fgb",
      title: "Cloud Resume Challenge: Azure Edition (Part 1)",
      description:
        "Deep dive into building a cloud resume using Azure. Covers AZ-900 certification, static website hosting, JavaScript visitor counter integration, Python Azure Functions API, and infrastructure as code with Terraform."
    }

  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/gabbyti-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Let’s Connect 📬"),
  subtitle:
    "Have a project in mind or just want to say hello? I'm always open to new conversations.",
  number: "", // Update with your Canadian number if needed
  email_address: "hello@gabrielibenye.com"
};

// Twitter Section

const twitterDetails = {
  userName: "_gabbyTI", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
